module.exports = __webpack_public_path__ + "static/media/featureIconSix.430316e6.webp";